import cn from 'classnames';
import type { FC, CSSProperties } from 'react';
import React, { memo, useCallback, useState } from 'react';

import { Button } from '@sravni/react-design-system/lib/Button';
import { Icon } from '@sravni/react-design-system/lib/Icon';
import { Text } from '@sravni/react-design-system/lib/Typography';
import { TailArrowRight, Cross } from '@sravni/react-icons';
import type { IAdvertising } from '@sravni/types/lib/advertising';
import type { IOrganization } from '@sravni/types/lib/organizations';

import style from './VitrinaBanner.module.scss';

interface ISideBannerData {
  organization: IOrganization;
  advertising?: IAdvertising;
  logo?: string;
}

export interface ISidebarBannerProps {
  bannerData: ISideBannerData;
  onClick: () => void;
  displayPixel: React.ReactNode;
  className?: string;
  styles?: CSSProperties;
}

export const VitrinaBanner: FC<ISidebarBannerProps> = memo((props: ISidebarBannerProps) => {
  const { bannerData, onClick, displayPixel, className, styles } = props;
  const [isShow, setIsShow] = useState(true);

  const { advertising, logo } = bannerData;
  const { sideBarBannerPanelColor, sideBarBannerTextColor } = advertising || {};

  const componentStyle = React.useMemo(
    () =>
      ({
        ...styles,
        '--side-bar-text-color': sideBarBannerTextColor,
        '--side-bar-background-color': sideBarBannerPanelColor,
      }) as CSSProperties,
    [sideBarBannerTextColor, sideBarBannerPanelColor, styles],
  );

  const handleClose = useCallback(() => {
    setIsShow(false);
  }, [setIsShow]);

  return isShow ? (
    <div
      className={cn(className, style.wrapper, {
        [style.backgroundColor]: sideBarBannerPanelColor,
        [style.textColor]: sideBarBannerTextColor,
      })}
      style={componentStyle}
    >
      {displayPixel}
      <div className={style.card} onClick={onClick}>
        <div className={style.mainInfo}>
          <img className={style.logo} src={logo} alt="Лого" />
          <Text size={12}>
            <div className={style.sideBarBannerText}>{advertising?.sideBarBannerText}</div>
            <Text size={8} className={cn(style.advertising, 'h-color-D60')}>
              Реклама | {bannerData.organization.name.full}
            </Text>
          </Text>
        </div>

        <Button className={style.btn} variant="text" color="dark">
          <Icon icon={<TailArrowRight />} className={style.arrow} />
        </Button>
      </div>

      <Icon className={style.close} icon={<Cross />} size={16} onClick={handleClose} />
    </div>
  ) : null;
});
